// src/components/SignIn.js
import React, { useState } from 'react';
import { Button, Container, Typography } from '@mui/material';
import { signInWithPopup } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth, googleProvider } from '../firebase';

export default function SignIn() {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user   = result.user;

      // Client‐side guard (UI picker hint isn’t enough)
      if (!user.email.endsWith('@eyp.at')) {
        await auth.signOut();
        throw new Error('Please sign in with your @eyp.at account');
      }

      // OK—go to your protected route
      navigate('/user-dashboard');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        mt: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Typography variant="h4" gutterBottom>
        Sign In
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={handleGoogleSignIn}
      >
        Sign in with Google
      </Button>
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Container>
  );
}
